import {useTranslation} from 'react-i18next';

import {Box, Grid, SxProps, Typography} from '@mui/material';

import {EmpionButton} from '../../../../../components/EmpionButton/EmpionButton';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {PageSection} from '../../../../../components/PageSection/PageSection';
import {orangeColors} from '../../../../../layouts/theme/designSystem';

export const DashboardFooterSection = () => {
  const {t} = useTranslation();

  const typographyColor = 'text.secondary';

  const pageSectionStyles: SxProps = {
    mt: 8,
    display: 'flex',
    justifyContent: 'center',
  };

  const paperStyles: SxProps = {
    width: {xs: '326px', sm: '500px', lg: '544px'},
    height: 'auto',
    minHeight: {xs: 'auto', sm: 'auto', lg: '182px'},
    backgroundColor: 'background.default',
    borderRadius: '16px',
    padding: {xs: '16px', sm: '16px', md: '32px 40px 32px 40px'},
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  const seeJobs = () => {
    window.open(process.env.REACT_APP_JOBS_BASE_URL, '_blank');
  };

  return (
    <PageSection bgColor={orangeColors[6]} sx={pageSectionStyles}>
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          mt: {xs: 4, sm: 4, md: 13},
          mb: {xs: 4, sm: 4, md: 13},
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: {xs: 'column', md: 'row'},
            alignItems: {xs: 'center', md: 'normal'},
          }}
          width={{xs: '100%', md: '900px'}}
        >
          <Box>
            <Box
              sx={{
                mb: 4,
                display: 'flex',
                justifyContent: 'center',
                width: {xs: '330px', sm: 'auto'},
              }}
            >
              <Typography
                variant='h2'
                sx={{
                  textAlign: 'center',
                }}
              >
                {t('applicantDashboard.footerDashboard.welcomeMessage')}
              </Typography>
            </Box>
            <EmpionPaper elevation={0} sx={paperStyles}>
              <Typography
                variant='body1'
                sx={{
                  color: typographyColor,
                }}
              >
                {t('applicantDashboard.footerDashboard.text')}
              </Typography>
              <EmpionButton
                sx={{
                  mt: 2,
                }}
                onClick={() => seeJobs()}
              >
                <Typography
                  variant='h4'
                  sx={{
                    color: 'white',
                  }}
                >
                  {t('applicantDashboard.footerDashboard.seeJobs')}
                </Typography>
              </EmpionButton>
            </EmpionPaper>
          </Box>
        </Box>
      </Grid>
    </PageSection>
  );
};
